import { render, staticRenderFns } from "./form-show-part.vue?vue&type=template&id=38a97ef3&"
import script from "./form-show-part.vue?vue&type=script&lang=js&"
export * from "./form-show-part.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports